import type { RootState } from 'APP/Store/CreateStore'

export const selectNativeCall = (state: RootState) => state.nativeCallIOS
